// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","276":"GuestLazyComponent"}[chunkId] + "." + {"46":"d01bff2a0e513a724ed4","276":"5a23b8dfa3b2f52d72c6"}[chunkId] + ".js";
};